import React from 'react';
//Components
import PopUp from './popup';
//Material-UI
import { TextField, Button } from '@material-ui/core';
//Icons
import { Edit } from 'tabler-icons-react';
//Context
import { useProductos } from './ProductosContext';

export default function EditProduct() {
    const {
        putProd,
        actions,
        editProduct,
        setEditProduct,
    } = useProductos();
    return (
        <PopUp
            name="editar"
            colorButton="default"
            textButton={
                <span className="productos-btn-content">
                    <Edit size={16} strokeWidth={1.75} /> Editar
                </span>
            }
            popupSeconButton="Cancelar"
            isContained="text"
            isActive={actions}
            title="Editar producto"
            popupBody={
                <div className="popupbody">
                    <div className="popuptextfield">
                        <TextField
                            id="edNombre"
                            label="NOMBRE DEL PRODUCTO"
                            fullWidth
                            onChange={(e) => {
                                setEditProduct({
                                    eNombre: e.target.value,
                                    EPP: editProduct.EPP,
                                    EPT: editProduct.EPT,
                                    sku: editProduct.sku,
                                });
                            }}
                            value={editProduct.eNombre}
                        />
                    </div>
                    <div className="popuptextfield">
                        <TextField
                            id="edSku"
                            label="CLAVE DEL PRODUCTO SKU"
                            fullWidth
                            disabled
                            value={editProduct.sku}
                        />
                    </div>
                    <div className="popuptextfield">
                        <TextField
                            id="edPzas"
                            label="PIEZAS/PAQUETE"
                            fullWidth
                            value={editProduct.EPP}
                            onChange={(e) => {
                                setEditProduct({
                                    eNombre: editProduct.eNombre,
                                    EPP: e.target.value,
                                    EPT: editProduct.EPT,
                                    sku: editProduct.sku,
                                });
                            }}
                        />
                    </div>
                    <div className="popuptextfield">
                        <TextField
                            id="edPaq"
                            name="paquetesPorTarima"
                            label="PAQUETES/TARIMA"
                            fullWidth
                            value={editProduct.EPT}
                            onChange={(e) => {
                                setEditProduct({
                                    eNombre: editProduct.eNombre,
                                    EPP: editProduct.EPP,
                                    EPT: e.target.value,
                                    sku: editProduct.sku,
                                });
                            }}
                        />
                    </div>
                </div>
            }
            popupPrimAction={
                <Button
                    color="primary"
                    variant="contained"
                    className="btn-guardar"
                    onClick={(e) => {
                        putProd(e);
                    }}
                >
                    Guardar
                </Button>
            }
        />
    );
}
